<template>
    <header :class="{ home: $route.meta.homePage }">
        <div class="wrapper">
            <a class="logo" v-if="$mq=='lg'" href="/"><img src="assets/img/logo.png" alt="logo"></a>


            <Navigation v-if="$mq=='lg'" />
        </div>

        <div v-if="$mq=='sm'"  class="mobileTitleWrap">
            <router-link v-if="!$route.meta.settingsPage && !$route.meta.supportPage" to="/settings" class="settings"></router-link>
            <a v-if="$route.meta.settingsPage || $route.meta.supportPage" class="settings active" @click="$router.go(-1)"></a>
            <div class="pageTitle">
                <div class="title">
                    {{ $route.meta.pageTitle }}
                </div>
                <div v-if="$route.meta.pageSubTitle" class="subTitle">
                    {{ $route.meta.pageSubTitle }}
                </div>
            </div>
            <div>
<!--                <router-link v-if="!$route.meta.settingsPage && !$route.meta.supportPage" to="/support" class="help"></router-link>-->
<!--                <i v-if="$route.meta.supportPage" class="avatar"></i>-->
            </div>
        </div>
    </header>
</template>

<script>
    import Navigation from './Navigation';

    export default {
        components: {
            Navigation
        },
        data() {
            return {

            }
        },
        mounted() {

        },

    }
</script>
